"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.requestAnimationFramePromise = requestAnimationFramePromise;
function requestAnimationFramePromise() {
    return new Promise(function (resolve) {
        return requestAnimationFrame(resolve);
    });
}


//////////////////
// WEBPACK FOOTER
// ./resources/assets/js/src/util/events.js
// module id = ./resources/assets/js/src/util/events.js
// module chunks = 0